import React from 'react'
import * as R from 'ramda'
import ReactDOM from 'react-dom'
import App from './App'
import Navigation from './helpers/NavigationHelper'
import { store } from './store'
import * as Actions from './store/actions'

// Init app function (called by index-desktop and index-mobile)
const loadApplication = (defaultDeviceType = 'web') => {
  const queriedDevice = Navigation.getParameterByName('device')

  if (!R.isNil(queriedDevice) && !R.isEmpty(queriedDevice)) {
    store.dispatch(Actions.application.onSetDevice(queriedDevice))

    // localStorage
    try {
      window.localStorage.setItem('device', queriedDevice)
    } catch (e) {}
  } else {
    try {
      // localStorage
      const previousDevice = window.localStorage.getItem('device')
      if (previousDevice) store.dispatch(Actions.application.onSetDevice(previousDevice))
      else store.dispatch(Actions.application.onSetDevice(defaultDeviceType))
    } catch (e) {
      store.dispatch(Actions.application.onSetDevice(defaultDeviceType))
    }
  }

  const DOMElement = window.document.getElementById('wrapper')

  if (__PRODUCTION__) {
    ReactDOM.render(<App store={store} />, DOMElement)
  } else {
    const { AppContainer } = require('react-hot-loader')
    const Redbox = require('redbox-react')

    const consoleErrorReporter = ({ error }) => {
      console.error(error)
      return <Redbox error={error} />
    }

    const render = Application => {
      ReactDOM.render(
        <AppContainer errorReporter={consoleErrorReporter}>
          <Application store={store} />
        </AppContainer>,
        DOMElement
      )
    }

    render(App)

    if (module.hot) {
      module.hot.accept('./App', () => { render(App) })
    }
  }
}

export { store, loadApplication }
